import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { ORGANIZATION_INVITATION_PERMISSIONS } from 'constants/organization_invitation_permissions'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events'
import { useTrack } from 'hooks/analytics_events/useTrack'
import {
  isScimConfiguredSelector,
  isSingleSelector,
  orgInvitationPermissionsSelector
} from 'selectors/current_organization'
import {
  isAdminOrOwnerSelector,
  isGroupAdminSelector
} from 'selectors/current_user'

import { ScimProTip } from './scim_pro_tip'

const AddNewUserButton = ({ url, onClick }) => (
  <Button
    as={Link}
    to={url}
    decoration="primary"
    onClick={onClick}
  >
    {I18n.t('publisher.admin.add_users')}
  </Button>
)

export const AddNewUser = () => {
  const track = useTrack()
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector)
  const isGroupAdmin = useSelector(isGroupAdminSelector)
  const isScimConfigured = useSelector(isScimConfiguredSelector)
  const isSingleOrganization = useSelector(isSingleSelector)
  const orgInvitationPermissions = useSelector(orgInvitationPermissionsSelector)

  const url = '/app/admin/invitations/new'

  const canInviteAsGroupAdmin = isGroupAdmin
    && [ORGANIZATION_INVITATION_PERMISSIONS.GROUP_ADMIN, ORGANIZATION_INVITATION_PERMISSIONS.USER].includes(orgInvitationPermissions)
  const canInviteAsEndUser = !isAdminOrOwner && !isGroupAdmin && orgInvitationPermissions === ORGANIZATION_INVITATION_PERMISSIONS.USER
  const canManageInvites = isAdminOrOwner || canInviteAsGroupAdmin || canInviteAsEndUser

  const addOnClick = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      properties: {
        cta_key: 'admin_user',
        cta_text: 'invite_user',
        cta_destination: 'invite_teammate_flow'
      }
    })
  }

  return (
    <>
      {!isScimConfigured && canManageInvites && <AddNewUserButton url={url} onClick={addOnClick} />}
      {!isSingleOrganization && isScimConfigured && canManageInvites && <ScimProTip />}
    </>
  )
}
